import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useCallback, useMemo, useState } from 'react';
import { Plus } from '@phosphor-icons/react';
import { Button } from 'antd';
import { BodyContainer } from '../../../elements';
import { CommonUtility, Tabs } from '../../../utility';
import { useSecondaryHeader } from '../../../hooks/useSecondaryHeader';
import { RouteTabs } from '../../../components';
import { InventoryImportTab } from './import';
import { InventoryImportFeedTab } from './feed';
import { AddInventoryPopup } from '../../../page-components/inventory';

const TabContainer = styled.div`
  margin-top: 15px;
`;

export function InventoryDetailScreen() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [addInventoryPopup, setAddInventoryPopup] = useState(false);

  const currentTab = useMemo(() => {
    if (pathname) {
      return CommonUtility.getSegmentByPosition(pathname, 4);
    }
    return null;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/inventory/import/${tabName}`);
  };

  const menus = [
    {
      text: 'Import',
      value: Tabs.InventoryTabs.new,
    },
    {
      text: 'Feed',
      value: Tabs.InventoryTabs.feed,
    },
  ];

  const openInventoryPopup = useCallback(() => {
    setAddInventoryPopup(true);
  }, []);

  useSecondaryHeader(
    () => (
      <RouteTabs
        items={menus}
        activeKey={currentTab}
        onChange={tabClicked}
        tabBarExtraContent={
          <Button
            variant="solid"
            color="default"
            icon={<Plus size={16} />}
            onClick={openInventoryPopup}
          >
            Inventory
          </Button>
        }
      />
    ),
    [currentTab, openInventoryPopup],
  );

  return (
    <BodyContainer className="tab-layout">
      <TabContainer>
        <Routes>
          <Route index element={<Navigate to="new" />} />
          <Route path="new" element={<InventoryImportTab />} />
          <Route path="feed" element={<InventoryImportFeedTab />} />
        </Routes>
      </TabContainer>
      <AddInventoryPopup
        open={addInventoryPopup}
        onClose={() => setAddInventoryPopup(false)}
      />
    </BodyContainer>
  );
}
